import styled from '@emotion/styled'

import { NavListSeparator } from '../../elements/NavListSeparator'

export const Separator = styled(NavListSeparator)`
  margin-top: 0;
`

export const NavListCreateNewButtonWrapper = styled.div``
